module.exports = __webpack_public_path__ + "static/media/red_carpet.73cf26db.jpeg";